export default "__VITE_ASSET__d027b867__"